import { BuilderActionValidationSummaryModel } from "../models/builder/builder-action-validation-summary.model";
import { BuilderBaseValidationSummaryModel } from "../models/builder/builder-base-validation-summary.model";
import { BuilderSendGroupValidationSummaryModel } from "../models/builder/builder-sendgroup-validation-summary.model";

/**
 * MAIN model containing validations for every step of the Wizard/Builder
 */
export enum BuilderSteps {
    /**
     * Step 1 - Add Document
     */
    AddDocuments = "AddDocuments",
    /**
     * Step 2 - Add Persons
     */
    AddPersons = "AddPersons",
    /**
     * Step 3 - Add Actions
     */
    AddActions = "AddActions",
    /**
     * Step 4 - Review and Send
     */
    ReviewAndSend = "ReviewAndSend",
}